const imageCache = new Set<string>();

export const preloadImage = (src: string) => {
  if (imageCache.has(src)) return Promise.resolve();

  return new Promise<void>((resolve) => {
    const img = new Image();
    img.src = src;

    img.onload = () => {
      imageCache.add(src);
      resolve();
    };

    img.onerror = () => {
      // даже если ошибка — не блокируем игру
      resolve();
    };
  });
};

export const preloadBoardAssets = async () => {
  const windowTypes = [
    "window",
    "window_short",
    "window_short_up",
  ];

  const states = ["_grey", "_light", "_close"];

  const basePath = "/img/stevehotel/window";

  const promises: Promise<void>[] = [];

  windowTypes.forEach((type) => {
    states.forEach((state) => {
      promises.push(preloadImage(`${basePath}/${type}${state}.svg`));
    });
  });

  promises.push(preloadImage("/img/stevehotel/fon.svg"));
  promises.push(preloadImage("/img/stevehotel/call/true.svg"));
  promises.push(preloadImage("/img/stevehotel/call/false.svg"));
  promises.push(preloadImage("/img/stevehotel/call/null.svg"));
  promises.push(preloadImage("/img/start.svg"));

  await Promise.all(promises);
};